<script lang="tsx">
import { defineComponent, ref, watch, computed } from "vue";

export default defineComponent({
  components: {},
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["change"],
  setup(props, { emit }) {
    return {
      onClick(e: any) {

        if(props.disabled) {
          return ;
        }
        e.stopPropagation();
        emit("change");
      },
    };
  },
  render(_ctx: any) {
    return (
      <label
        style={{
          opacity:_ctx.$props.disabled?0.5:1,
          cursor: _ctx.$props.disabled?'not-allowed':undefined
        }} 
        class="el-checkbox el-checkbox--default"
      >
        <span
          class={{
            "el-checkbox__input": true,
            "is-indeterminate": _ctx.$props.indeterminate,
            "is-checked": _ctx.$props.checked,
          }}
          tabindex="0"
          role="checkbox"
        >
          <input class="el-checkbox__original" type="checkbox" value="false" onClick={_ctx.onClick} />
          <span 
           style={{
            cursor: _ctx.$props.disabled?'not-allowed':undefined
          }} 
          class="el-checkbox__inner"></span>
        </span>
      </label>
    );
  },
});
</script>

<style lang="scss" scoped>
.el-checkbox__inner {
  transition: none;
  &::after {
    transition: none;
  }
}
</style>
